import React, {createContext, useContext, useState} from "react";
import {CurrentAction} from "../../shared/constants/Constant";

export interface IAppContext {
  backURLs: string[];
  currentAction: CurrentAction;
  pushBackURL: (url: string) => void;
  popBackURL: () => string;
  setCurrentAction: (currentAction: CurrentAction) => void;
  getCurrentAction: () => CurrentAction;
}

const initialCurrentAction: CurrentAction = {
  isUploading: false,
  isEditing: false,
  allowNavigationAway: true
}

interface IState {
  backURLs: string[];
  currentAction: CurrentAction;
}

const initialContext: IAppContext = {
  backURLs: [],
  currentAction: initialCurrentAction,
  pushBackURL: () => {
    // empty function body
  },
  popBackURL: () => "",
  setCurrentAction: () => {
    // empty function body
  },
  getCurrentAction: () => initialCurrentAction
};

const initialState: IState = {
  backURLs: [],
  currentAction: initialCurrentAction
};

const AppContext = createContext<IAppContext>(initialContext);

interface IProps {
  children: any;
}

export const AppProvider = (props: IProps) => {
  const [state, setState] = useState(initialState);

  const pushBackURL = (url: string) => {
    const urls: string[] = state.backURLs;
    urls.push(url);

    setState((ps) => ({...ps, backURLs: urls}));
  };

  const popBackURL = (): string => {
    if (state.backURLs && state.backURLs.length > 0) {
      const urls: string[] = state.backURLs;
      const topUrl: string = urls.pop() || "";

      setState((prevState => ({...prevState, backURLs: urls})));

      return topUrl;
    } else {
      return "";
    }
  }

  const setCurrentAction = (currentAction: CurrentAction) => {
    setState((prevState => ({...prevState, currentAction: currentAction})));
  }

  const getCurrentAction = (): CurrentAction => {
    return state.currentAction;
  }

  return (
    <AppContext.Provider value={{...state, pushBackURL, popBackURL, setCurrentAction, getCurrentAction}}>
      {props.children}
    </AppContext.Provider>
  );
};

export const useAppContext = (): IAppContext => useContext(AppContext);
